import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface GiftVoucherFormState {
    name: string;
    surname1: string;
    surname2: string;
    phone: string;
    email: string;
    sendEmail: boolean;
    isGifting: boolean;
    formValid: boolean;
}

export function createInitialState(): GiftVoucherFormState {
    return {
        name: '',
        surname1: '',
        surname2: '',
        phone: '',
        email: '',
        sendEmail: false,
        isGifting: false,
        formValid: true,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'gift-voucher-form', resettable: true })
export class GiftVoucherFormStore extends Store<
    GiftVoucherFormState
> {
    constructor() {
        super(createInitialState());
    }
}
